import {Component, OnDestroy, OnInit} from '@angular/core';
import {Statement} from '../../../domain/accounts/statement';
import {CommonComponent} from '../../shared/common/common.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {Router} from '@angular/router';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';
import {AccountService} from '../../../services/account.service';
import {CustomerDetail} from '../../../domain/customer/customer-detail';
import * as moment from 'moment/moment';
import {CustomerProfileService} from '../../../services/customer-profile.service';
import {CustomerProfile} from '../../../domain/customer/customer-profile';
import {Profile} from '../../../domain/authentication/profile';
import {StorageItem} from '../../../enums/storage-item';
import {LocalStorageService} from 'angular-2-local-storage';
import {Movement} from '../../../domain/accounts/movement';
import {CustomerDetailService} from '../../../services/customer-detail.service';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DatePipe} from "@angular/common";
import 'moment/locale/es';

class Month {
  name: string;
  startDate: any;
  endDate: any;
}
@Component({
  selector: 'app-transaction-history',
  templateUrl: './transaction-history.component.html',
  styleUrls: ['./transaction-history.component.scss']
})

export class TransactionHistoryComponent extends CommonComponent implements OnInit, OnDestroy {
  balance?: number;
  today: moment.Moment;
  lastMonthSameDay: moment.Moment;
  months: Month[];
  selectedValue: Month;
  customerDetail: CustomerDetail;
  movements: Movement[];
  currentMovement: Movement;
  profileDetail: CustomerProfile;
  profileLanguage: string;
  pastMonthName: string;
  twoMonthsAgoName: string;
  displayMovement = false;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    public translate: TranslateService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    router: Router,
    protected dialogService: DialogService,
    private accountsService: AccountService,
    private customerProfileService: CustomerProfileService,
    private localStorage: LocalStorageService,
    private customerDetailService: CustomerDetailService,
    private datePipe: DatePipe
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    translate.addLangs(['es', 'en']);
    translate.setDefaultLang('es');
    const profile: Profile = this.localStorage.get(StorageItem.PROFILE);
    if (profile?.locale) {
      translate.use(this.getValidLanguage(profile.locale.substring(0, 2)));
    } else {
      translate.use(this.getValidLanguage(window.location.pathname.substring(1, 3)));
    }
    this.translate.onLangChange.subscribe(event => {
      moment.locale(event.lang); // Cambiar el locale global de moment
    });
  }

  ngOnInit(): void {
    this.loadingModalOn();
    this.getCustomerDetail();
    this.getMonths();
  }

  getMonths(){
    this.loadingModalOn();

    this.customerProfileService.customerProfile$.pipe(takeUntil(this.destroyed$)).subscribe(
      (response: any) => {
        this.profileDetail = response;
        this.translate.use(this.getValidLanguage(this.profileDetail.language));
        moment.locale(this.translate.currentLang);
      }, error => {
        this.msgError(error);
      }
    );
  }
  getCustomerDetail() {
    this.loadingModalOn();
    this.customerDetailService.customerDetail$.pipe(takeUntil(this.destroyed$)).subscribe(
      (response: any) => {
        this.customerDetail = response;
        if (this.customerDetail?.accounts.length > 0) {
          this.getBalance().subscribe({
            next: (response2: any) => {
              this.balance = response2.balance;
            }, error: (error) =>
          {
            this.msgError(error);
          }
        }).add(
            () => {
              this.getTransactions();
            }
          );
        }else {
          this.getTransactions();
        }
      }, error => {
        this.loadingModalOff();
        this.msgError(error);
      }
    );
  }
  getTransactions() {
    this.today = moment();
    this.lastMonthSameDay = this.today.clone().subtract(1, 'month');
    const startDate = this.lastMonthSameDay.format('YYYY-MM-DD');
    const endDate = this.today.format('YYYY-MM-DD');
    const offset = moment().format('Z');
    this.accountsService.getMovementsOffset(this.customerDetail?.account.id, startDate, endDate, offset).subscribe({
      next: (response: any) => {
        this.movements = response;
      }, error: (error)  => {
        switch (error.status) {
          case 409:
            break;
          default:
            this.msgError(error, $localize`:@@balanceComponentGeneralError:Ocurrió un error al obtener tu estado de cuenta`);
            break;
        }
      }
    }).add(
        () => {
          this.loadingModalOff();
        }
      );
  }
  hasMovementData(mov: Movement): boolean {
    // tslint:disable-next-line:max-line-length
    return (mov.reference != null || mov.reference !== undefined) || (mov.merchantName != null || mov.merchantName !== undefined) || (mov.merchantCity != null || mov.merchantCity !== undefined) || (mov.merchantId != null || mov.merchantId !== undefined);
  }

  getBalance (){
    return this.accountsService.getBalance(this.customerDetail?.account.id);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.unsubscribe();
  }
  setCurrentMovement (mov: Movement){
    this.currentMovement = mov;
  }

  getFormattedDate(date: Date | string | undefined): string {
    const lang = this.translate?.currentLang || 'en';
    return this.datePipe.transform(date, 'MMM dd yyyy', undefined, lang) || '';
  }

}
